import React from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useChannelQuery } from '@annunciate/query';
import { View, MemoizedCollection } from '@annunciate/ui/dist/components';
export const Discover = () => {
    const { isPending, error, data } = useChannelQuery();
    if (error)
        console.error(error);
    const root = data?.channel?.collection;
    return (React.createElement(View, { style: { flexGrow: 1 } },
        React.createElement(React.Fragment, null,
            isPending && (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
                React.createElement(Text, null, "Loading..."),
                React.createElement(LinearProgress, { style: { marginVertical: 10 } }))),
            (error || (!isPending && !root)) && React.createElement(Text, null, "Error..."),
            root && (React.createElement(MemoizedCollection, { collection: root })))));
};
//# sourceMappingURL=Discover.js.map